export default function getEnv(name) {
  return process.env[name];
}
